export default "__VITE_PUBLIC_ASSET__f6ca906f__"